import React, { useEffect } from "react";
import PageLayout from "@/components/layout/pageLayout/PageLayout";
import DashboardHeader from "../dashboard/DashboardHeader";
import DashboardSidebar from "../dashboard/DashboardSidebar";
import DashboardMain from "../dashboard/DashboardMain";
import ComparativeAnalysisCard from "../dashboard/components/cards/comparativeAnalysis/ComparativeAnalysisCard";
import { useAuth } from "@/providers/AuthProvider";
import StudentListSection from "./components/studentListSection/StudentListSection";
import { useDashboard } from "../dashboard/useDashboard";
import { useLocation } from "react-router-dom";

const NAV_ITEMS = [
    { id: "results", label: "Resultados por prueba", icon: "📊" },
    { id: "custom-comparative-view", label: "Análisis comparativo", icon: "📈" },
    { id: "competences", label: "Competencias", icon: "🏆" },
    { id: "thematic-areas", label: "Áreas temáticas", icon: "📊" },
    { id: "institution-students", label: "Estudiantes", icon: "📊" },
];

const CoordinatorDashboard: React.FC = () => {
    const { user } = useAuth();
    const location = useLocation();
    const cameFrom = location.state?.from;

    useEffect(() => {
        document.body.classList.add("solid-public-bg");
        return () => document.body.classList.remove("solid-public-bg");
    }, []);

    const institutionIdFromUrl = new URLSearchParams(window.location.search).get(
        "institutionId",
    );
    const institutionId =
        user?.role === "Facilitador"
            ? institutionIdFromUrl
            : institutionIdFromUrl || user?.institution?.id;

    const isFacilitatorViewing =
        user?.role === "Facilitador" && institutionIdFromUrl;

    const backPath = isFacilitatorViewing
        ? cameFrom || "/facilitator-panel/user-management"
        : undefined;

    const {
        simulations,
        dashboardData,
        selectedSimulation,
        activeSection,
        isLoading,
        error,
        handleSimulationChange,
        handleNavigation,
    } = useDashboard({ institutionId });

    return (
        <PageLayout
            header={
                <DashboardHeader
                    simulations={simulations}
                    selectedSimulationId={selectedSimulation?.id || ""}
                    onSimulationChange={handleSimulationChange}
                    isLoading={isLoading}
                    backButtonPath={backPath}
                />
            }
            sidebar={
                <DashboardSidebar
                    selectedSimulation={selectedSimulation}
                    activeSection={activeSection}
                    navItems={NAV_ITEMS}
                    onNavigate={handleNavigation}
                    globalScore={dashboardData?.summary.score || 0}
                />
            }
            main={
                <DashboardMain
                    isLoading={isLoading}
                    error={error}
                    dashboardData={dashboardData}
                    simulations={simulations}
                    disabledSections={["comparative", "historical", "recommendations"]}
                    extraSections={[
                        {
                            id: "custom-comparative-view",
                            component: ComparativeAnalysisCard,
                            getProps: ({ dashboardData }) => ({
                                tests: dashboardData?.tests,
                            }),
                            extraProps: {
                                view: "vsGlobal",
                                showTabs: false,
                            },
                        },
                        {
                            id: "institution-students",
                            component: StudentListSection,
                            getProps: ({ dashboardData }) => ({
                                tests: dashboardData?.tests,
                            }),
                            extraProps: {
                                institutionId: institutionId,
                                selectedSimId: selectedSimulation?.id,
                            },
                        },
                    ]}
                />
            }
        />
    );
};

export default CoordinatorDashboard;
